export default __webpack_public_path__ + "static/media/Racializedpeople_fr.2a861ea1.svg";